import { TreeActions } from "@react-awesome-query-builder/core";
import * as drag from "./drag";
var tree = TreeActions.tree,
  group = TreeActions.group,
  rule = TreeActions.rule;
export { tree, group, rule, drag };